import { QueryClient, useQuery } from '@tanstack/react-query';
import { wbsApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const adjustmentsQueryOptions = (accountId: string) => ({
  queryKey: queryKeys.wbs.adjustments(accountId),
  queryFn: ({ signal }: { signal?: AbortSignal }) =>
    wbsApiClient.getAccountAdjustments(accountId, toCancelToken(signal)),
  staleTime: 0,
  meta: { errorContext: 'WBS account adjustments' },
});

/** @registry Adjustments recorded against one WBS account. */
export function useWbsAdjustments(
  accountId: string | null | undefined,
  enabled = true,
) {
  return useQuery({
    ...adjustmentsQueryOptions(accountId ?? ''),
    enabled: enabled && !!accountId,
  });
}

/** Reads an account's adjustments on demand (e.g. the pre-delete guard). */
export function fetchWbsAdjustments(qc: QueryClient, accountId: string) {
  return qc.fetchQuery(adjustmentsQueryOptions(accountId));
}
